// extracted by mini-css-extract-plugin
export default {"button":"nOQhyY","disabled":"k2BjXj","mobileButton":"j7HNSc"};